// elementy we viewport
function isOnScreen(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  // true, jeśli element styka się z widocznym obszarem okna
  return (
    rect.top < windowHeight &&
    rect.bottom > 0 &&
    rect.left < windowWidth &&
    rect.right > 0
  );
}

function checkInVP() {
  const elements = document.querySelectorAll('._js_inViewport');
  elements.forEach((el) => {
    if (isOnScreen(el)) {
      el.classList.add('__js_onScreen');
      el.classList.add('_js_inViewport');
    }
  });

  // ponowne wywołanie co ~690 ms
  setTimeout(checkInVP, 690);
}

// inicjalne uruchomienie
setTimeout(checkInVP, 690);